import {
  GET_PRIMARY_COUNTRY_LIST_ACTION,
  GET_PRIMARY_STATE_LIST_ACTION,
  GET_PRIMARY_CITY_LIST_ACTION,
  GET_ORGANIZATION_ACTION,
  EDIT_ORGANIZATION_ACTION,
  GET_ALTERNATE_COUNTRY_LIST_ACTION,
  GET_ALTERNATE_STATE_LIST_ACTION,
  GET_ALTERNATE_CITY_LIST_ACTION,
} from '../constants/action-types'
import { OrganisationData } from '../Actions'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'

const initialState = {
  isLoading: false,
  errorMessage: '',
  primary_country: [],
  primary_state: [],
  primary_city: [],
  alternate_country: [],
  alternate_state: [],
  alternate_city: [],
  organizationProfile: {},
}

const reducer = persistReducer(
  {
    storage,
    key: 'organization_profile',
    whitelist: [
      'primary_country',
      'primary_state',
      'primary_city',
      'alternate_country',
      'alternate_state',
      'alternate_city',
      'organizationProfile',
    ],
  },
  (state: OrganisationData = initialState, action: ActionTypes) => {
    switch (action.type) {
      // Primary Country
      case GET_PRIMARY_COUNTRY_LIST_ACTION.GET_PRIMARY_COUNTRY_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }
      case GET_PRIMARY_COUNTRY_LIST_ACTION.GET_PRIMARY_COUNTRY_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          primary_country: action.payload as any,
        }

      case GET_PRIMARY_COUNTRY_LIST_ACTION.GET_PRIMARY_COUNTRY_LIST_FAILED:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
        }

      // Primary State
      case GET_PRIMARY_STATE_LIST_ACTION.GET_PRIMARY_STATE_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }
      case GET_PRIMARY_STATE_LIST_ACTION.GET_PRIMARY_STATE_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          primary_state: action.payload as any,
        }

      case GET_PRIMARY_STATE_LIST_ACTION.GET_PRIMARY_STATE_LIST_FAILED:
        return {
          ...state,
          errorMessage: action.payload,
          isLoading: false,
        }

      // Primary City

      case GET_PRIMARY_CITY_LIST_ACTION.GET_PRIMARY_CITY_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }
      case GET_PRIMARY_CITY_LIST_ACTION.GET_PRIMARY_CITY_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          primary_city: action.payload as any,
        }

      case GET_PRIMARY_CITY_LIST_ACTION.GET_PRIMARY_CITY_LIST_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }
      // Alternate Country
      case GET_ALTERNATE_COUNTRY_LIST_ACTION.GET_ALTERNATE_COUNTRY_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }
      case GET_ALTERNATE_COUNTRY_LIST_ACTION.GET_ALTERNATE_COUNTRY_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          alternate_country: action.payload as any,
        }

      case GET_ALTERNATE_COUNTRY_LIST_ACTION.GET_ALTERNATE_COUNTRY_LIST_FAILED:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
        }

      // Alternate State
      case GET_ALTERNATE_STATE_LIST_ACTION.GET_ALTERNATE_STATE_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }
      case GET_ALTERNATE_STATE_LIST_ACTION.GET_ALTERNATE_STATE_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          alternate_state: action.payload as any,
        }

      case GET_ALTERNATE_STATE_LIST_ACTION.GET_ALTERNATE_STATE_LIST_FAILED:
        return {
          ...state,
          errorMessage: action.payload,
          isLoading: false,
        }

      // Alternate City

      case GET_ALTERNATE_CITY_LIST_ACTION.GET_ALTERNATE_CITY_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }
      case GET_ALTERNATE_CITY_LIST_ACTION.GET_ALTERNATE_CITY_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          alternate_city: action.payload as any,
        }

      case GET_ALTERNATE_CITY_LIST_ACTION.GET_ALTERNATE_CITY_LIST_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }
      // get profile data
      case GET_ORGANIZATION_ACTION.GET_ORGANIZATION_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }
      case GET_ORGANIZATION_ACTION.GET_ORGANIZATION_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          organizationProfile: action.payload as any,
        }

      case GET_ORGANIZATION_ACTION.GET_ORGANIZATION_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      case EDIT_ORGANIZATION_ACTION.EDIT_ORGANIZATION_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }
      case EDIT_ORGANIZATION_ACTION.EDIT_ORGANIZATION_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      case EDIT_ORGANIZATION_ACTION.EDIT_ORGANIZATION_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      default:
        return state
    }
  }
)

export default reducer
